import { jsxs as e, jsx as o } from "react/jsx-runtime";
import n from "styled-components";
import i from "../../../utils/colors.js";
import { useSidenavContext as p } from "../context.js";
const d = n.button`
  border: none;
  padding: 0 0 0 18px;
  background: 0 0;
  outline: 0;
  cursor: pointer;
  width: 60px;
  height: 60px;

  span:first-child {
    transform-origin: 0% 0%;
  }

  span:nth-last-child(2) {
    transform-origin: 0% 100%;
  }

  &:focus,
  &:hover {
    span {
      background: ${i.orange};
    }
  }
`, t = n.span`
  display: block;
  width: ${(r) => r.width || "24"}px;
  height: 4px;
  margin-bottom: 5px;
  position: relative;
  background-color: ${i.darkGrey};
  transform-origin: 4px 0px;
  transition: background-color 150ms, -webkit-transform 0.4s;
  transition: transform 0.4s, background-color 150ms;
  transition: transform 0.4s, background-color 150ms, -webkit-transform 0.4s;
`, u = ({ label: r = "Toggle navigation" }) => {
  const { setIsOpen: s, isOpen: a } = p();
  return /* @__PURE__ */ e(
    d,
    {
      "aria-label": r,
      "aria-expanded": a ? "true" : "false",
      title: r,
      onClick: () => s(!0),
      type: "button",
      children: [
        /* @__PURE__ */ o(t, {}),
        /* @__PURE__ */ o(t, { width: 18 }),
        /* @__PURE__ */ o(t, {})
      ]
    }
  );
};
export {
  u as default
};
